// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type CheckCircle24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckCircle24Filled: FC<CheckCircle24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="m10.74 16.14 6.345-6.345-1.26-1.26-5.085 5.085-2.565-2.565-1.26 1.26 3.825 3.825ZM12 21a8.762 8.762 0 0 1-3.51-.709 9.089 9.089 0 0 1-2.857-1.924 9.089 9.089 0 0 1-1.924-2.857A8.764 8.764 0 0 1 3 12c0-1.245.236-2.415.709-3.51a9.089 9.089 0 0 1 1.924-2.857A9.089 9.089 0 0 1 8.49 3.709 8.764 8.764 0 0 1 12 3c1.245 0 2.415.236 3.51.709a9.089 9.089 0 0 1 2.857 1.924 9.089 9.089 0 0 1 1.924 2.857A8.762 8.762 0 0 1 21 12a8.762 8.762 0 0 1-.709 3.51 9.089 9.089 0 0 1-1.924 2.857 9.089 9.089 0 0 1-2.857 1.924A8.762 8.762 0 0 1 12 21Z" />
        </svg>
    );
};

export default CheckCircle24Filled;
